export default "__VITE_ASSET__C9N4eMqY__"